/***
 * @file:
 * @author: caojianping
 * @Date: 2021-05-25 15:09:15
 */
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { CloseTabUrl } from './page-tab.model';

@Injectable({ providedIn: 'root' })
export class PageTabService {
  tabChange$ = new Subject();
  closeAllTab$ = new Subject();

  closeTab(closedUrl?: string, redirectUrl?: string) {
    const url: CloseTabUrl = {
      closedUrl,
      redirectUrl,
    };
    this.tabChange$.next(url);
  }

  closeAllTab() {
    this.closeAllTab$.next();
  }
}
